import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';

export default class PortfoliosMetricScoresIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = window.location.href.split('?')[0];
      let params = {};
      params['methodology_id'] = $('#metric_scores_table').attr('data-filters-methodology-id');
      params['esg_category'] = $('#metric_scores_table').attr('data-filters-esg-category');
      params['sfdr_pai'] = $('#metric_scores_table').attr('data-filters-sfdr-pai');
      params['as'] = 'true';
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('.portfolio-metrics-filter').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {

      // Prevent default
      ev.preventDefault();

      // Hide tooltip
      $('.tooltip').tooltip('hide');

      // Set value to symbol if a fund; otherwise value
      let val = suggestion;

      // Create/update filter
      let attr = $(this).attr('data-attr');
      $('#metric_scores_table').attr('data-filters-' + attr, val);
      reloadWithSelectedParams();

      // Blur typeahead
      $(this).blur();

    });

    // On selecting archived
    $('.portfolio-metrics-radio').on('change', function(ev, suggestion) {
      let val = this.checked;
      let attr = $(this).attr('data-attr');
      $('#metric_scores_table').attr('data-filters-' + attr, val);
      reloadWithSelectedParams();
    })

  }

}
